<template>
  <v-col cols="3" class="pb-0">
    <v-row>
      <v-col cols="auto">
        <v-icon class="mr-2">{{ icon }}</v-icon>
        <span>{{ label }}</span>
      </v-col>
      <v-col class="text-right">
        <strong class="mr-1">{{ value.base }}</strong>
        <span>px</span>
      </v-col>
    </v-row>
    <v-slider
      v-model="value.base"
      :max="value.max"
      :min="value.min"
      :step="step"
      hide-details
      :disabled="disabled"
      @input="$emit('input', value)"
    />
  </v-col>
</template>

<script>
export default {
  name: "ConfigSlider",

  props: ["value", "icon", "label", "disabled"],

  computed: {
    step() {
      return Math.floor(Math.max(this.value.max / 50, 1));
    }
  }
};
</script>
